/**
 * Parse array from URL param (comma-separated values)
 * @param value - URL parameter value
 * @returns Array of strings
 */
export const parseArrayParam = (value: string | null): string[] => {
  return value ? value.split(",").filter(Boolean) : [];
};

/**
 * Parse number from URL param
 * @param value - URL parameter value
 * @returns Number or undefined
 */
export const parseNumberParam = (value: string | null): number | undefined => {
  return value ? parseFloat(value) : undefined;
};
